import { z } from 'zod';
import { REAUTH_ACTIONS } from './reauth.enums';

/**
 * `POST /auth/confirm-pin` body. Regex matches the digit-string PIN
 * format enforced when the PIN was first set (`POST /users/pin`).
 */
export const ConfirmPinSchema = z.object({
  pin: z
    .string()
    .trim()
    .regex(/^\d{5}$/, 'pin must be 5 digits'),
  action: z.enum(REAUTH_ACTIONS),
});

/**
 * `POST /auth/confirm-pin` response. The `reauthToken` is presented via
 * `X-Reauth-Token` on the subsequent destructive request; single-use,
 * scoped to `action`.
 */
export const ReauthTokenResponseSchema = z.object({
  reauthToken: z.string(),
  action: z.enum(REAUTH_ACTIONS),
  expiresAt: z.iso.datetime(),
});
